import React, { useState } from "react";

const FAQ = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div className="page_faq">
      {items.map((item, i) => (
        <div className="faq_item" key={i}>
          <div className="faq_question" onClick={() => toggle(i)}>
            <span className="faq_question_text">{item.q}</span>
            <span className={`faq_toggle${openIndex === i ? " open" : ""}`}>+</span>
          </div>
          {openIndex === i && (
            <div className="faq_answer">{item.a}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQ;
